export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/countdown.210ad866.worker.js");
}
